import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import CategorisedGamesGrid from 'components/Lobby/CategorisedGamesGrid'
import useFilterGames from 'components/Lobby/hooks/useFilterGames'
import useFavoriteGames from 'hooks/useFavoriteGames'

/**
 * HomePageGamesV1 displays the game grid on the homepage (variant v1)
 *
 * @param {Object} props - Component props
 * @param {string} props.selectedFilter - Currently selected game filter
 * @param {function} props.setSelectedFilter - Function to update the selected filter
 * @returns {JSX.Element} React component that renders the games grid section
 */
const HomePageGamesV1 = ({ selectedFilter, setSelectedFilter }) => {
  const navigate = useNavigate()
  const {
    gameCategory,
    languageData,
    // changeMenuTab,
    gameSubCategory,
    selectedLanguageCode,
    subCatLoading
  } = useFilterGames({ category: true, selectedFilter, setSelectedFilter })
  const { favoriteGamesList, toggleFavorite } = useFavoriteGames()

  return (
    <>
      <CategorisedGamesGrid
        isHomePage
        categorySlug={gameCategory?.casinoCategories?.rows?.[0]?.slug}
        gameCategory={gameCategory}
        languageData={languageData}
        navigate={navigate}
        // changeMenuTab={changeMenuTab}
        toggleFavorite={toggleFavorite}
        gameSubCategory={gameSubCategory}
        favoriteGamesList={favoriteGamesList}
        selectedLanguageCode={selectedLanguageCode}
        subCatLoading={subCatLoading}
        setSelectedFilter={setSelectedFilter}
      />
    </>
  )
}

export default HomePageGamesV1
